import type { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

/** Rahmen der Seiten zu Widerruf und Kündigung (altes Layout wie Impressum und AGB, Sitzung „Aufräumen“). */
export function RechtSeitenRahmen({
  titel,
  beschreibung,
  pfad,
  noindex = false,
  children,
}: {
  titel: string;
  beschreibung: string;
  pfad: string;
  noindex?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background">
      <SEO title={`${titel} | MusiKonzept`} description={beschreibung} path={pfad} />
      {noindex && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <Header />
      <main className="pt-20">
        <div className="container mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
